import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import 'bootstrap/dist/css/bootstrap.min.css' // Removed Bootstrap CSS
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/styles/responsive.css'
import './assets/styles/icons.css' // Import our icon fonts
import './assets/styles/course-variables.css' // Import course variables first
import './assets/styles/course-components.css' // Import course components second
import './assets/styles/course-views.css' // Import course views third
import './plugins/vee-validate'
import './assets/tailwind.css'; // Import Tailwind CSS last to avoid conflicts

// Import PrimeVue and Tailwind
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura'; // Example theme
import ToastService from 'primevue/toastservice'; // Import ToastService
import 'primeicons/primeicons.css';

// Import i18n setup
import i18n from './i18n';

import BannerList from './components/BannerList.vue'
import AppButton from './components/ui/Button.vue'
import AppCard from './components/ui/Card.vue'
import AppInput from './components/ui/Input.vue'
import VariablesCSS from './components/shared/VariablesCSS.vue'

// Load Google Fonts
const link = document.createElement('link')
link.rel = 'stylesheet'
link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap'
document.head.appendChild(link)

// Create app instance
const app = createApp(App)

// Global error handler - Updated to use Toast
app.config.errorHandler = (err, instance, info) => {
  console.error('Global error:', err);
  console.error('Error info:', info);
  
  // Use Toast for displaying errors
  // Ensure $toast is available on the instance where error occurred, or use global instance
  const toast = instance?.$toast || app.config.globalProperties.$toast;
  if (toast) {
    toast.add({
      severity: 'error', 
      summary: 'Error', 
      detail: 'An unexpected error occurred: ' + err.message, 
      life: 8000
    });
  } else {
    console.error("Toast service not available to display error.");
    
    // Fallback to using window.setTimeout instead of _ctx.setTimeout
    window.setTimeout(() => {
      alert('An error occurred: ' + err.message);
    }, 0);
  }
  
  // Remove old store dispatch for notifications
  // if (store) {
  //   store.dispatch('addNotification', {
  //     type: 'error',
  //     message: 'An error occurred: ' + err.message,
  //     timeout: 8000
  //   })
  // }
};

// Register plugins
app.use(router)
app.use(store)
app.use(PrimeVue, {
  theme: {
    preset: Aura
  }
});
app.use(ToastService); // Register ToastService
app.use(i18n); // Register i18n

// Add global setTimeout function with proper binding to avoid Illegal invocation errors
app.config.globalProperties.setTimeout = function(...args) {
  return window.setTimeout.apply(window, args);
};

// Register global components
app.component('BannerList', BannerList)
app.component('AppButton', AppButton)
app.component('AppCard', AppCard)
app.component('AppInput', AppInput)
app.component('VariablesCSS', VariablesCSS)

// Mount app
app.mount('#app')
